// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__OE6lP","section-1":"styles_section-1__ZfEBg","content":"styles_content__c3XzG","section-2":"styles_section-2__dGcD2"};